import { ReactSVG } from 'react-svg'
import styles from './_reportPostButton.module.scss'
import { useLabLogin } from '../../../../utils/hooks/useLabLogin'
import { Context, useState } from 'react'
import { PostContextProps } from '../topics/[id]/posts/[post_id]'
import { CommunityContextProps } from './CommunityLayout'
import PostReportModal from './ReportPostModal'
import { CommunityPost } from '../../../../__generated__/graphql'
import classNames from 'classnames'

const ReportPostButton: React.FC<{
  context: Context<PostContextProps | CommunityContextProps>
  post: CommunityPost
  buttonTextReport?: string
  buttonTextReported?: string
  buttonsClassName?: string
  onReportModalClose?: () => void
}> = ({
  context,
  post,
  buttonTextReport,
  buttonTextReported,
  buttonsClassName,
  onReportModalClose
}) => {
  const [reportModalOpen, setReportModalOpen] = useState(false)
  const [isPostReported, setIsPostReported] = useState(post?.reported)

  const openReportModal = useLabLogin(context, () => setReportModalOpen(true))

  return (
    <>
      <button
        className={classNames(styles.reportButton, buttonsClassName, {
          [styles.reportButtonReported]: isPostReported
        })}
        disabled={isPostReported}
        onClick={openReportModal}
      >
        {isPostReported ? buttonTextReported : buttonTextReport}
        <ReactSVG src="../../../../../images/lab/report_icon.svg" />
      </button>

      {reportModalOpen && (
        <PostReportModal
          onClose={() => {
            setReportModalOpen(false)
            onReportModalClose?.()
          }}
          onReported={() => setIsPostReported(true)}
          postId={post.id}
        />
      )}
    </>
  )
}

export default ReportPostButton
